import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950" role="contentinfo">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-chat-heart-line text-xl text-primary-500"></i>
              </div>
              <span className="font-heading text-lg text-white whitespace-nowrap">樱花动漫91</span>
            </Link>
            <p className="text-foreground-200 text-sm leading-relaxed">
              樱花动漫91提供漫画全集下拉式阅读体验，海量在线漫画资源，好看的漫画免费在线看，每日更新最新漫画章节。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-white text-base mb-4">热门分类</h4>
            <ul className="space-y-2">
              {[
                { label: '恋爱漫画', to: '/category/lianai' },
                { label: '热血漫画', to: '/category/rexue' },
                { label: '奇幻漫画', to: '/category/qihuan' },
                { label: '搞笑漫画', to: '/category/gaoxiao' },
              ].map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-foreground-200 hover:text-primary-400 text-sm transition-colors duration-200 whitespace-nowrap"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-white text-base mb-4">更多分类</h4>
            <ul className="space-y-2">
              {[
                { label: '恐怖漫画', to: '/category/kongbu' },
                { label: '校园漫画', to: '/category/xiaoyuan' },
                { label: '冒险漫画', to: '/category/maoxian' },
                { label: '悬疑漫画', to: '/category/xuanyi' },
              ].map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-foreground-200 hover:text-primary-400 text-sm transition-colors duration-200 whitespace-nowrap"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-white text-base mb-4">关于我们</h4>
            <ul className="space-y-2">
              {[
                { label: '品牌介绍', to: '/about' },
                { label: '用户口碑', to: '/about#reputation' },
                { label: '联系我们', to: '/about#contact' },
              ].map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-foreground-200 hover:text-primary-400 text-sm transition-colors duration-200 whitespace-nowrap"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-200 hover:bg-primary-500 hover:text-white transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-200 hover:bg-primary-500 hover:text-white transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-200 hover:bg-primary-500 hover:text-white transition-colors duration-200" aria-label="QQ">
                <i className="ri-qq-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-300 text-xs">
            &copy; 2026 樱花动漫91. 樱花动漫91漫画全集，下拉式漫画在线阅读，在线漫画资源大全
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-300">
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">用户协议</a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}